import React from "react";
import { Badge } from "react-bootstrap";
import { Slash } from "react-feather";
import {
  IWorkPipelineItem,
  WORK_PIPELINE_TEMPLATE_DISABLED_LABELS,
} from "../../interfaces";

const SQL_HINT =
  "Every template row for this domain is inactive in SQL. Tracking only — the domain is still worked as normal.";
const DEV_HINT =
  "A dev set it to Disabled and a manager approved it in Block review. Tracking only — the domain stays on the board.";

/** "Auto Template Disabled" / "SKU Template Disabled"; tracking only. */
export const TemplateDisabledTags: React.FC<{
  item: Pick<IWorkPipelineItem, "templatesDisabled">;
  className?: string;
}> = ({ item, className = "mt-1 me-1" }) => {
  const t = item.templatesDisabled;
  if (!t) return null;
  const kinds = (["auto", "sku"] as const).filter((kind) => t[kind]);
  return (
    <>
      {kinds.map((kind) => (
        <Badge
          key={kind}
          bg="dark"
          className={className}
          title={t.byDev ? DEV_HINT : SQL_HINT}
        >
          <Slash size={11} className="me-1" />
          {WORK_PIPELINE_TEMPLATE_DISABLED_LABELS[kind]}
        </Badge>
      ))}
      {/* Dev blocks from before devs named the template. */}
      {t.byDev && !kinds.length && (
        <Badge bg="dark" className={className} title={DEV_HINT}>
          <Slash size={11} className="me-1" />
          Template Disabled
        </Badge>
      )}
    </>
  );
};
